const Td = ({
  type,
  children
}) => {
  let text = children;

  if(type === 'price' && text) text = `$${text || 0}`;

  return (
    <td>{text || '---'}</td>
  );
};

export {
  Td
};